import { matchPath } from 'react-router'
import { getCurrentPath } from 'src/helpers/browser'
import { DREAM_HOME, RENTAL_PROPERTY, RENT_BUY } from 'src/constants/gems'

const MARKET_TAB = 'MARKET_TAB'
const SOLO_BUYER = 'SOLO_BUYER'

export const FROM = {
  DREAM_HOME,
  RENTAL_PROPERTY,
  RENT_BUY,
  MARKET_TAB,
  SOLO_BUYER
}

export const EXPLORE_MARKET_TABS = {
  POPULAR_MARKETS: 'score',
  BIGGER_HOUSE: 'sqft',
  CHEAPER_BUYS: 'price',
  FASTEST_MOVE: 'timeline'
}

export const PATH_HELPERS = {
  home: {
    matchPath:
      '/reports/:clientId([-0-9A-Fa-f]{36})/home/:homeId([0-9A-Fa-f]{24})',
    regex: new RegExp(
      /^\/reports\/([-0-9A-Fa-f]{36})\/home\/([0-9A-Fa-f]{24}|new)/
    ),
    buildPath: (clientId, homeId) =>
      clientId && homeId ? `/reports/${clientId}/home/${homeId}` : '/'
  },
  markets: {
    matchPath: '/reports/:clientId([-0-9A-Fa-f]{36})/markets',
    regex: new RegExp(/^\/reports\/([-0-9A-Fa-f]{36}|initialize)\/markets/),
    buildPath: (clientId, marketPath) =>
      clientId ? `/reports/${clientId}/markets${marketPath || ''}` : '/'
  },
  buy: {
    matchPath: '/reports/:clientId([-0-9A-Fa-f]{36})/buy',
    regex: new RegExp(/^\/reports\/([-0-9A-Fa-f]{36}|initialize)\/buy/),
    buildPath: (clientId, destination) =>
      clientId ? `/reports/${clientId}/buy${destination || ''}` : '/'
  },
  zip: {
    matchPath:
      '/reports/:clientId([-0-9A-Fa-f]{36})/markets/:zipcode([0-9]{5})',
    regex: new RegExp(
      /^\/reports\/([-0-9A-Fa-f]{36}|initialize)\/markets\/([0-9]{5})/
    ),
    buildPath: (clientId, zipcode) =>
      clientId ? `/reports/${clientId}/markets/${zipcode || ''}` : '/'
  }
}

export const getClientIdFromPath = () => {
  const pathname = getCurrentPath()
  const clientMatch = matchPath(pathname, {
    path: '/reports/:clientId([-0-9A-Fa-f]{36})'
  })
  return clientMatch ? clientMatch.params.clientId : null
}

export const getHomeIdFromPath = () => {
  const pathname = getCurrentPath()
  const homeMatch = matchPath(pathname, {
    path: '/reports/:clientId?/home/:homeId([0-9A-Fa-f]{24})'
  })
  return homeMatch ? homeMatch.params.homeId : null
}

export const OVERLAY_HELPERS = {
  purchasing: {
    overlay: 'purchasing',
    matchPath: `${PATH_HELPERS.home.matchPath}/purchasing/:gemKey([^/]+?)`,
    getOrigin: () => {
      const homeRoutes = getCurrentPath().match(PATH_HELPERS.home.regex)
      return homeRoutes ? homeRoutes[0] : null
    },
    buildPath: gemKey => {
      const homeRoutes = getCurrentPath().match(PATH_HELPERS.home.regex)
      return homeRoutes && gemKey
        ? `${homeRoutes[0]}/purchasing/${gemKey.toLowerCase()}`
        : '/not-found'
    }
  },
  cashout: {
    overlay: 'cashout',
    matchPath: `${PATH_HELPERS.home.matchPath}/cashout/:gemKey([^/]+?)`,
    getOrigin: () => {
      const homeRoutes = getCurrentPath().match(PATH_HELPERS.home.regex)
      return homeRoutes ? homeRoutes[0] : null
    },
    buildPath: gemKey => {
      const homeRoutes = getCurrentPath().match(PATH_HELPERS.home.regex)
      return homeRoutes && gemKey
        ? `${homeRoutes[0]}/cashout/${gemKey.toLowerCase()}`
        : '/not-found'
    }
  }
}
